import { render, staticRenderFns } from "./Responsible.vue?vue&type=template&id=4b5d856c&scoped=true"
import script from "./Responsible.vue?vue&type=script&lang=js"
export * from "./Responsible.vue?vue&type=script&lang=js"
import style0 from "./Responsible.vue?vue&type=style&index=0&id=4b5d856c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5d856c",
  null
  
)

export default component.exports